import CardClass from "../../../CardClass";
import PropTypes from "prop-types";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIIconButton from "@mui/material/IconButton";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIFormControl from "@mui/material/FormControl";
import MUIFormHelperText from "@mui/material/FormHelperText";
import MUIInput from "@mui/material/Input";
import MUIInputAdornment from "@mui/material/InputAdornment";
import MUIInputLabel from "@mui/material/InputLabel";
import DialogSearchHcpcsCode from "../../../Dialog/Search/DialogSearchHcpcsCode";
import DialogSearchModifierCode from "../../../Dialog/Search/DialogSearchModifierCode";
import TileHcpcsCode from "../../../Tile/TileHcpcsCode";
import TileModifierCode from "../../../Tile/TileModifierCode";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminFeeScheduleGeneral extends CardClass {
  static contextType = MainContext; // For legacy class components

  /**
   * Render the content of the card.
   */
  renderContent() {
    let feeSchedule = this.props.feeSchedule;
    let hcpcsCode = null;
    let modifierCode = null;

    if (feeSchedule && feeSchedule.executiveId !== null) {
      hcpcsCode = this.context.hcpcsCodesIndexed[feeSchedule.hcpcsCodeId];
    }

    if (feeSchedule && feeSchedule.directorId !== null) {
      modifierCode =
        this.context.modifierCodesIndexed[feeSchedule.modifierCodeId];
    }

    // HCPCS Code
    const handleEditHcpcsCode = () => {
      this.setState({ hcpcsCodeDialogOpen: true });
    };
    const handleClearHcpcsCode = () => {
      this.props.onChange({ hcpcsCodeId: null });
    };
    const hcpcsCodesButtons = [
      <MUIIconButton onClick={handleEditHcpcsCode}>
        <MUIEditIcon />
      </MUIIconButton>,
    ];

    if (hcpcsCode) {
      hcpcsCodesButtons.push(
        <MUIIconButton onClick={handleClearHcpcsCode}>
          <MUIDeleteIcon />
        </MUIIconButton>,
      );
    }

    // Modifier Code
    const handleEditModifierCode = () => {
      this.setState({ modifierCodeDialogOpen: true });
    };
    const handleClearModifierCode = () => {
      this.props.onChange({ modifierCodeId: null });
    };
    const modifierCodeButtons = [
      <MUIIconButton onClick={handleEditModifierCode}>
        <MUIEditIcon />
      </MUIIconButton>,
    ];

    if (modifierCode) {
      modifierCodeButtons.push(
        <MUIIconButton onClick={handleClearModifierCode}>
          <MUIDeleteIcon />
        </MUIIconButton>,
      );
    }
    const formatToTwoDecimalPlaces = (value) => {
      if (value === undefined || value === null || isNaN(value)) {
        return "0.00";
      }
      const parsedValue = parseFloat(value);
      return parsedValue.toFixed(2);
    };

    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={4}>
          <TileHcpcsCode
            hcpcsCode={hcpcsCode}
            iconButtons={hcpcsCodesButtons}
            label="HCPCS Code"
            required={true}
            error={this.props.validationIssues.hcpcsCodeId ? true : false}
            helperText={
              this.props.validationIssues.hcpcsCodeId
                ? this.props.validationIssues.hcpcsCodeId
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <TileModifierCode
            modifierCode={modifierCode}
            iconButtons={modifierCodeButtons}
            label="Modifier Code"
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUIFormControl
            fullWidth
            variant="standard"
            required={true}
            error={this.props.validationIssues.amount ? true : false}
          >
            <MUIInputLabel shrink>Amount</MUIInputLabel>
            <MUIInput
              autoFocus={true}
              defaultValue={
                this.props.feeSchedule
                  ? formatToTwoDecimalPlaces(this.props.feeSchedule.amount)
                  : ""
              }
              inputProps={{
                maxLength: 255,
                style: { textAlign: "right" },
              }}
              onInput={(e) => {
                // Restrict user input to numbers and at most one decimal point
                e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                const decimalCount = e.target.value.split(".")[1]?.length || 0;
                if (decimalCount > 2) {
                  e.target.value = e.target.value.slice(
                    0,
                    e.target.value.indexOf(".") + 3,
                  );
                }
              }}
              onBlur={(e) => {
                const parsedValue = parseFloat(
                  e.target.value.replace(/[^0-9.]/g, ""),
                );
                this.props.onChange({
                  amount: parsedValue ? parsedValue : null,
                });
              }}
              startAdornment={
                <MUIInputAdornment position="start">$</MUIInputAdornment>
              }
            />
            {this.props.validationIssues.amount && (
              <MUIFormHelperText>
                {this.props.validationIssues.amount}
              </MUIFormHelperText>
            )}
          </MUIFormControl>
        </MUIGrid>
        <DialogSearchHcpcsCode
          open={this.state.hcpcsCodeDialogOpen}
          onClose={() => this.setState({ hcpcsCodeDialogOpen: false })}
          onSelect={(hcpcsCode) => {
            this.props.onChange({ hcpcsCodeId: hcpcsCode.id });
          }}
        />
        <DialogSearchModifierCode
          open={this.state.modifierCodeDialogOpen}
          onClose={() => this.setState({ modifierCodeDialogOpen: false })}
          onSelect={(modifierCode) => {
            this.props.onChange({ modifierCodeId: modifierCode.id });
          }}
        />
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
